<template>
  <div class="accordion accordion-flush" id="accordionFlushExample">
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button
          id="btn-accordion"
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#flush-collapseOne"
          aria-expanded="false"
          aria-controls="flush-collapseOne"
        >
          Concentración de Riesgo
        </button>
      </h2>

      <div
        id="flush-collapseOne"
        class="accordion-collapse collapse"
        data-bs-parent="#accordionFlushExample"
      >
        <h4 class="text-center mt-5 display-5">Concentración de Riesgo</h4>

        <select
          v-model="selectedOption"
          class="form-select"
          aria-label="Default select example"
        >
          <option value="Porcentaje">Porcentaje</option>
          <option value="Saldo Capital">Total Saldo Vencido A La Fecha</option>
          <option value="Formulas">Formulas</option>
        </select>

        <div class="table-responsive mt-4">
          <table class="table table-bordered table-hover align-middle text-center">
            <thead class="table-light">
              <tr>
                <th scope="col">Sucursal / Producto</th>
                <th scope="col">Total</th>
                <th v-for="(producto, index) in productos" :key="index" scope="col">
                  {{ producto }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(departamento, dIndex) in departamentos" :key="dIndex" @click="onClickTotalDepartamento(departamento)">
                <th scope="row" class="text-start">{{ departamento }}</th>

                <!-- TOTAL POR DEPARTAMENTO (2da columna) + CLICK -->
                <td
                  role="button"
                  class="fw-bold"
                  
                >
                  <!-- Saldo Capital -->
                  <p v-if="selectedOption === 'Saldo Capital'">
                    {{ formatoNumero(totalDepartamento(departamento)) }} {{ moneda }}
                  </p>

                  <!-- Formulas -->
                  <div v-else-if="selectedOption === 'Formulas'">
                    <MathFormula
                      v-if="totalDepartamento(departamento)"
                      :formula="formulaTotalDepartamento(departamento)"
                    />
                  </div>

                  <!-- Porcentaje -->
                  <div v-else>
                    <p v-if="totalDepartamento(departamento)">
                      {{
                        formatearPorcentaje(
                          (totalDepartamento(departamento) / (sumaTotalSaldo || 1)) * 100
                        )
                      }}
                      %
                    </p>
                  </div>
                </td>

                <!-- COLUMNAS POR PRODUCTO -->
                <td v-for="(producto, pIndex) in productos" :key="pIndex">
                  <p v-if="selectedOption === 'Saldo Capital'">
                    {{
                      valores[departamento]?.[producto] != null
                        ? formatoNumero(valores[departamento][producto]) + " " + moneda
                        : ""
                    }}
                  </p>

                  <div v-else-if="selectedOption === 'Formulas'">
                    <MathFormula
                      v-if="valores[departamento]?.[producto]"
                      :formula="formula(valores[departamento]?.[producto], producto)"
                    />
                  </div>

                  <div v-else>
                    <p v-if="valores[departamento]?.[producto] != null">
                      {{ formatearPorcentaje(valores[departamento][producto]) }} %
                    </p>
                  </div>
                </td>
              </tr>

              <!-- TOTALES POR PRODUCTO -->
              <tr class="table-dark">
                <th scope="col">Riesgo por producto</th>

                <!-- Celda "Total" (total general) -->
                <th scope="col">
                  <p v-if="selectedOption === 'Porcentaje'">100.0 %</p>

                  <p v-else-if="selectedOption === 'Saldo Capital'">
                    {{ formatoNumero(sumaTotalSaldo) }} {{ moneda }}
                  </p>

                  <div v-else-if="selectedOption === 'Formulas'">
                    <MathFormula
                      v-if="sumaTotalSaldo"
                      :formula="`= \\frac{${formatoNumero(sumaTotalSaldo)} ${moneda}}{${formatoNumero(
                        sumaTotalSaldo
                      )} ${moneda}}`"
                    />
                  </div>
                </th>

                <th v-for="(producto, index) in productos" :key="index" scope="col">
                  <p v-if="selectedOption === 'Porcentaje'">
                    {{
                      formatearPorcentaje(
                        ((totalSaldoProductos?.[producto] || 0) / (sumaTotalSaldo || 1)) * 100
                      )
                    }}
                    %
                  </p>

                  <p v-else-if="selectedOption === 'Saldo Capital'">
                    {{ formatoNumero(totalSaldoProductos?.[producto] || 0) }} {{ moneda }}
                  </p>

                  <div v-else-if="selectedOption === 'Formulas'">
                    <MathFormula
                      v-if="totalSaldoProductos?.[producto]"
                      :formula="`\\frac{${formatoNumero(
                        totalSaldoProductos[producto]
                      )} ${moneda}}{${formatoNumero(sumaTotalSaldo)} ${moneda}}`"
                    />
                  </div>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MathFormula from "../MathFormula.vue";

export default {
  name: "TablaConcentracionRiesgo",
  components: { MathFormula },
  props: {
    departamentos: { type: Array, required: true },
    productos: { type: Array, required: true },
    departamentoXProducto: { type: Object, required: true },
    totalSaldoProductos: { type: Object, required: true },
    open: { type: Boolean, default: false },
    asesor: { type: String, default: "" },

    // para que el click imprima el asesor actual
    asesorSeleccionado: { type: [String, Number], default: "" },
  },
  data() {
    return {
      valores: {},
      selectedOption: "Saldo Capital",
      moneda: "lps",
      sumaTotalSaldo: 0,
    };
  },
  mounted() {
    this.recalcular();
  },
  watch: {
    open(newValue) {
      if (newValue) document.getElementById("btn-accordion")?.click();
    },

    // cambia la vista -> recalcular
    selectedOption() {
      this.recalcular();
    },

    // cuando entra nueva data por props -> recalcular (sin acumular)
    departamentoXProducto: {
      deep: true,
      handler() {
        this.recalcular();
      },
    },
    totalSaldoProductos: {
      deep: true,
      handler() {
        this.recalcular();
      },
    },
  },
  methods: {
    // ✅ ÚNICO punto de cálculo (evita acumulaciones)
    recalcular() {
      // 1) sumaTotalSaldo SIEMPRE desde cero
      this.sumaTotalSaldo = Object.values(this.totalSaldoProductos || {}).reduce(
        (acc, v) => acc + (Number(v) || 0),
        0
      );

      // 2) valores SIEMPRE desde cero
      const nuevo = {};
      const dxp = this.departamentoXProducto || {};

      if (this.selectedOption === "Porcentaje") {
        for (const departamento in dxp) {
          nuevo[departamento] = {};
          const productosObj = dxp[departamento] || {};

          for (const producto in productosObj) {
            const valor = Number(productosObj[producto]) || 0;
            const totalProd = Number(this.totalSaldoProductos?.[producto]) || 0;
            nuevo[departamento][producto] = totalProd > 0 ? (valor / totalProd) * 100 : 0;
          }
        }
      } else {
        // "Saldo Capital" y "Formulas": valor directo (la fórmula se arma en render)
        for (const departamento in dxp) {
          nuevo[departamento] = {};
          const productosObj = dxp[departamento] || {};

          for (const producto in productosObj) {
            nuevo[departamento][producto] = Number(productosObj[producto]) || 0;
          }
        }
      }

      this.valores = nuevo;
    },

    // fórmula por celda producto
    formula(numerador, producto) {
      const denom = Number(this.totalSaldoProductos?.[producto]) || 0;
      return ` = ( \\frac{${this.formatoNumero(numerador)}} {  ${this.formatoNumero(denom)}}) `;
    },

    // TOTAL POR DEPARTAMENTO
    totalDepartamento(departamento) {
      const productosObj = this.departamentoXProducto?.[departamento] || {};
      return Object.values(productosObj).reduce((acc, v) => acc + (Number(v) || 0), 0);
    },

    // fórmula total depto / total general
    formulaTotalDepartamento(departamento) {
      return `= \\frac{${this.formatoNumero(this.totalDepartamento(departamento))} ${
        this.moneda
      }}{${this.formatoNumero(this.sumaTotalSaldo)} ${this.moneda}}`;
    },

    onClickTotalDepartamento(departamento) {
      console.log("CLICK TOTAL ->", {
        departamento,
        asesorSeleccionado: this.asesorSeleccionado,
      });


      // this.$router.push({ name: 'TablaCreditosMora' })
      const routeData = this.$router.resolve({
      name: 'TablaCreditosDepartamento',
      query: {
        sucursal: (departamento? departamento: "MOSTRAR TODAS") ,
        asesor: (this.asesor)? this.asesor : "",
        tipoCartera: 0,
        estado:  'ACTIVOS',
      } 
    })

    window.open(routeData.href, '_blank', 'noopener')

  },
    

    formatoNumero(numero) {
      return new Intl.NumberFormat("en-US").format(Number(numero) || 0);
    },
    formatearPorcentaje(numero) {
      if (isNaN(numero)) return "";
      return Number(numero).toFixed(1);
    },
  },
};
</script>

<style scoped>
#accordionFlushExample {
  border: 1px solid #e0e0e0;
  background-color: #464646;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}
</style>
